import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { connect, useSelector } from 'react-redux';
import { CFCProps } from 'types';
import { Loading } from 'carbon-components-react';
import { ChevronDown16, ChevronUp16 } from '@carbon/icons-react';
import { RootState } from 'redux/root.reducer';
import { selectorAlertNotificationShowHide } from '../../redux/session/selectors';

const AppSwitcher: React.FC<Props> = ({ apps, isLoadingApps }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const alertNotificationToggle = useSelector(
    selectorAlertNotificationShowHide
  );

  const handleAppClick = (app: any) => {
    if (app.authorized) {
      if (app.client_id.toLowerCase().includes('collaborate')) {
        window.location.href = `${process.env.REACT_APP_IDENTITY_WEB_URL}/login?clientId=${app.client_id}&return=/`;
        return;
      }
      if (app.client_id.toLowerCase().includes('sentinel')) {
        window.open(`${app.base_url}`);
        return;
      }
      window.location.href = app.base_url;
    } else {
      if (app.isAppDown) {
        window.location.href = `${process.env.REACT_APP_IDENTITY_WEB_URL}/app-down?name=${app.name}`;
        return;
      }

      if (app.client_id.toLowerCase().includes('locate')) {
        window.open(`${process.env.REACT_APP_LOCATE_PROMO}`);
      } else if (app.client_id.toLowerCase().includes('collaborate')) {
        window.open(`${process.env.REACT_APP_COLLABORATE_PROMO}`);
      } else if (app.client_id.toLowerCase().includes('automate')) {
        window.open(`${process.env.REACT_APP_AUTOMATE_PROMO}`);
      }
    }
  };

  useEffect(() => {
    if (
      apps.length > 0 &&
      process.env.REACT_APP_SHOW_SENTINEL_IN_APP_SWITCHER === 'true'
    ) {
      const sentinelData = {
        id: 'sentinel',
        name: 'BYDA',
        description: 'Before You Dig Australia',
        authorized: true,
        base_url: 'https://smarterwx.1100.com.au/',
        client_id: 'SWXSentinel',
        isAppDown: false
      };
      apps.push(sentinelData);
    }
  }, [apps]);

  const appDom = document.getElementById('app');

  return (
    <>
      {apps.length > 0 ? (
        <div className="app-switcher">
          <div className="app-switcher-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <ChevronUp16 /> : <ChevronDown16 />}
          </div>
          {isOpen &&
            appDom !== null &&
            ReactDOM.createPortal(
              <div
                className={`${
                  alertNotificationToggle
                    ? 'noti-alert-notification-app-switcher'
                    : ''
                } app-switcher-panel`}
              >
                {isLoadingApps ? (
                  <div className="app-switcher-loading">
                    <Loading withOverlay={false} />
                  </div>
                ) : (
                  <>
                    {apps.map((app) => (
                      <div
                        key={app.id}
                        className="app-switcher-item"
                        onClick={() => handleAppClick(app)}
                      >
                        <div className="app-switcher-item-name">{app.name}</div>
                        <div
                          className={`app-switcher-item-desc${
                            !app.authorized
                              ? app.isAppDown
                                ? ' is-down'
                                : ' is-unauthorize'
                              : ''
                          }`}
                        >
                          {app.authorized
                            ? app.description
                            : app.isAppDown
                            ? 'Currently unavailable'
                            : 'Learn more'}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>,
              appDom
            )}
        </div>
      ) : null}
    </>
  );
};

const mapStateToProps = ({ siteCache }: RootState) => ({
  apps: siteCache.apps,
  isLoadingApps: siteCache.isLoadingApps
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

export default React.memo(connector(AppSwitcher));
